// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { QuickWinFeedback } from "../schema";

export function serialize_QuickWinFeedback_internal(value: QuickWinFeedback): unknown {
  return ((value: { isPositive: boolean }): unknown => {
    return {
      isPositive: ((value: boolean): unknown => {
        return value;
      })(value["isPositive"]),
    };
  })(value);
}
export function serialize_QuickWinFeedback(obj: QuickWinFeedback): string {
  return renderJsonWithNumbersAsBigint(serialize_QuickWinFeedback_internal(obj));
}
export function deserialize_QuickWinFeedback_internal(value: unknown): ParserResult<QuickWinFeedback> {
  return ((
    value: unknown,
  ): ParserResult<{
    isPositive: boolean;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/QuickWinFeedback]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/QuickWinFeedback]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "isPositive")) {
      return { success: false, reason: `[#/components/schemas/QuickWinFeedback/isPositive]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'isPositive'.` };
    }
    const parsed_isPositive = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/QuickWinFeedback/isPositive]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["isPositive"]);
    })();
    if (!parsed_isPositive.success) {
      return { success: false, reason: parsed_isPositive.reason };
    }
    return { success: true, value: { isPositive: parsed_isPositive.value } };
  })(value);
}
export function deserialize_QuickWinFeedback(str: string): ParserResult<QuickWinFeedback> {
  return deserialize_QuickWinFeedback_internal(parseJsonWithNumbersAsBigint(str));
}
